export const FLEX_GAP_PX = 5;
export const BROWSE_PEOPLE_CARD_LIMIT = 6;
